// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4cd860a8","453":"419a5d54","729":"8600db25","732":"3a063a13","977":"80d23c31"}[chunkId] + ".chunk.js";
};